import { defineComponent as _defineComponent } from 'vue'
import ScaleOut from "@/components/scale-out-component.vue";
import BreadCrumbComponent from "@/components/bread-crumb-component.vue";
import debounce from "debounce";

import { onMounted, ref } from "vue";
import { useParamsSync } from "@/composables/use-params-sync";
import useHttpRequest from "@/composables/use-http-request";

import CourseWork from "@/interfaces/courseWork.interface";
import { FetchCourseWorksDto } from "@/dtos/fetch-course-works.dto";
import { useRoute, useRouter } from "vue-router/composables";
import { getFormattedIntake } from "@/helpers/getFormattedIntake";
import ListIntakesComponent from "@/components/list-intakes.component.vue";
import { useConfirmPopup } from "@/composables/use-confirm-popup";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'course-works',
  setup(__props) {

let scope: { row: CourseWork; $index: number };

const route = useRoute();
const router = useRouter();
const loading = ref(false);
const loadingError = ref(false);

const courseWorkTitle = ref("");
const titleSearch = ref("");

const totalCourseWorks = ref(0);
const pageSize = ref(10);
const currentPage = ref(1);
const tableProps = {
  border: true,
  stripe: true,
};

const courseWorks = ref<CourseWork[]>([]);

const formattedIntakes = (coursework: CourseWork) => {
  const intakes = coursework.course_work_intakes;
  return intakes.map((intake) => {
    const intakeGroups = coursework.course_intake_batch_groups?.filter(
      (group) => group.course_intake_batch_id == intake.course_intake_batch_id
    );

    const intakeGroupsList = intakeGroups
      ?.map((group) => group.title)
      .join(", ");

    return `${intake.course_unit.course_unit_code} in ${getFormattedIntake(
      intake.course_intake_batch
    )} ${intakeGroupsList?.length ? `(${intakeGroupsList})` : ""}`;
  });
};

const getCourseWorks = async () => {
  const request = await useHttpRequest<FetchCourseWorksDto>({
    method: "GET",
    url: `course-work/fetch-many?page=${currentPage.value}&pageSize=${pageSize.value}&titleSearch=${titleSearch.value}&course_work_set_id=${route.params.courseWorkSetId}`,
    loadingProperty: loading,
    showSuccessMessage: false,
    errorLoadingProperty: loadingError,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "COURSE_WORKS FETCHED SUCCESSFULLY"
  ) {
    courseWorks.value = request.course_works;
    totalCourseWorks.value = request.totalCourseWorks;
    courseWorkTitle.value = request.course_work_set.title;
    window.scrollTo(0, 0);
  }
};

const onSearch = debounce(function () {
  getCourseWorks();
}, 500);

onMounted(() => {
  // Setup Params Syncing
  useParamsSync(
    { key: "ps", value: pageSize },
    { key: "p", value: currentPage },
    { key: "s", value: titleSearch }
  );
  getCourseWorks();
});

const onTableChange = (queryInfo: any) => {
  if (queryInfo) {
    if (queryInfo.type == "page" || queryInfo.type == "size") {
      currentPage.value = queryInfo.page;
      pageSize.value = queryInfo.pageSize;
      getCourseWorks();
    }
  }
};

const deleteCourseWork = async (id: string) => {
  const confirmed = await useConfirmPopup({
    title: "Confirm Delete",
    message:
      "This will permanently delete this course work. Do you want to Continue?",
    type: "DANGER",
    buttonText: "Delete",
  });

  if (!confirmed) return;

  const request = await useHttpRequest<{ success: boolean; message: string }>({
    method: "DELETE",
    url: `course-work/delete-one/${id}`,
    loadingProperty: loading,
    showSuccessMessage: true,
    errorLoadingProperty: loadingError,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "Course Work Deleted Successfully"
  ) {
    getCourseWorks();
  }
};

const showIntakes = async (courseWorkId: string) => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    courseWork: CourseWork;
  }>({
    method: "GET",
    url: `course-work/fetch-intakes/${courseWorkId}`,
    loadingProperty: loading,
    showSuccessMessage: false,
    errorLoadingProperty: loadingError,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "Coursework intakes fetched successfully"
  ) {
    courseWorks.value = courseWorks.value.map((courseWork) => {
      if (courseWork.course_work_id == request.courseWork.course_work_id) {
        courseWork.course_work_intakes = request.courseWork.course_work_intakes;
        courseWork.course_intake_batch_groups =
          request.courseWork.course_intake_batch_groups;
      }
      return courseWork;
    });
  }
};

const courseWorkDetails = (id: string) => {
  router.push({
    path: `/dashboard/course-work-details/${id}`,
  });
};

const manageCourseWorkResults = (id: string) => {
  router.push({
    name: "course-work-results-management",
    params: {
      courseWorkId: id,
    },
  });
};

const handleActionsSelection = (command: string) => {
  const commandEventFired = command.split("#");
  const commandName = commandEventFired[0];
  const id = commandEventFired[1];
  if (commandName === "course-work-details") {
    courseWorkDetails(id);
  }
  if (commandName === "edit-course-work") {
    router.push({
      name: "EditCourseWork",
      params: {
        courseWorkId: id,
      },
    });
  }
  if (commandName === "manage-results") {
    manageCourseWorkResults(id);
  }
  if (commandName === "delete-course-work") {
    deleteCourseWork(id);
  }
};

return { __sfc: true,scope, route, router, loading, loadingError, courseWorkTitle, titleSearch, totalCourseWorks, pageSize, currentPage, tableProps, courseWorks, formattedIntakes, getCourseWorks, onSearch, onTableChange, deleteCourseWork, showIntakes, courseWorkDetails, manageCourseWorkResults, handleActionsSelection, ScaleOut, BreadCrumbComponent, ListIntakesComponent }
}

})